import { ThemeProvider, createTheme, useTheme } from "@mui/material/styles";
import { CasterMoldPage } from "./CasterMoldPage";
import { eqpThemeExtension } from "../../shared/theme";

const CasterMold = () => {
  const baseTheme = useTheme();

  // Reuse EAF theme extension — shared EQP palette (viewer, status, tree colors)
  const extendedTheme = createTheme({
    ...baseTheme,
    palette: {
      ...baseTheme.palette,
      ...eqpThemeExtension.palette,
    },
  });

  return (
    <ThemeProvider theme={extendedTheme}>
      <CasterMoldPage />
    </ThemeProvider>
  );
};

export default CasterMold;
